import React from "react";

function IndustriesWeServe() {
  const industries = [
    {
      name: "Oil & Gas",
      image: "/assets/images/Industry/oil and gas.jpg",
    },
    {
      name: "Petrochemical",
      image: "/assets/images/Industry/Pertroleumchemical.jpg",
    },
    {
      name: "Power",
      image: "/assets/images/Industry/power.jpg",
    },
    {
      name: "LNG",
      image: "/assets/images/Industry/LNG.png",
    },
    {
      name: "Fertilizer",
      image: "/assets/images/Industry/Fertilizer.jpg",
    },
    {
      name: "Cement",
      image: "/assets/images/Industry/Cement.jpeg",
    },
    {
      name: "Steel",
      image: "/assets/images/Industry/steel.jpg",
    },
    {
      name: "Marine/Offshore",
      image: "/assets/images/Industry/Marine_FPSO.jpg",
    },
    {
      name: "Food & Beverage",
      image: "/assets/images/Industry/Food & Beverage.jpg",
    },
    {
      name: "Aviation",
      image: "/assets/images/Industry/Aviation.jpg",
    },
    {
      name: "Renewable Energy",
      image: "/assets/images/Industry/Renewable Energy.jpg",
    },
    {
      name: "Green Hydrogen",
      image: "/assets/images/Industry/Green Hydrogen.jpg",
    },
  ];

  return (
    <div>
      {/* Industries We Serve section start */}
      <div className="rts-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center title-area-ten mb--60">
                <h2 className="title">
                  Industries We <span>Serve</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {industries.map((industry, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-12">
                <div className="industry-card">
                  <div className="industry-image-wrapper">
                    <img
                      src={industry.image}
                      alt={industry.name}
                      className="industry-image"
                    />
                    <div className="industry-overlay">
                      <h5 className="industry-title">{industry.name}</h5>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Industries We Serve section end */}
    </div>
  );
}

export default IndustriesWeServe;
